module.exports = "<app-navbar></app-navbar>\r\n\r\n<div class=\"main\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n<app-footer></app-footer>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main